import React from "react";
import {SvgIcon, SvgIconProps} from "@mui/material";

const BatmanSvg = (props: any) => (<svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg" >
        <path d="M1.02067 1V33" stroke="#88888866" strokeOpacity="0.4" strokeLinecap="round" strokeDasharray="5 5"/>
        <path d="M1 18.0226H33" stroke="#88888866" strokeOpacity="0.4" strokeLinecap="round" strokeDasharray="5 5"/>
        <path d="M5.30257 18.0226L8.814 12.8418L12.1337 18.0226M21.8872 18.0226L25.2068 12.8418L28.7183 18.0226" stroke="#089981" strokeWidth="2"/>
        <path d="M1.28941 23.9435L5.3025 18.0226M32.7313 23.9435L28.7182 18.0226M12.1336 18.0226L12.845 19.1328H21.1757L21.8871 18.0226" stroke="#A40C0C" strokeWidth="2"/>
    </svg>
)

const Batman: React.FC<SvgIconProps> = React.memo((props) => (
    <SvgIcon {...props}>
        {BatmanSvg(props)}
    </SvgIcon>
));
export default Batman